import React from 'react'
import PropTypes from 'prop-types'

const IconLike = ({size = 16}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.57933 1.38783C6.77428 0.94919 7.20927 0.666504 7.68928 0.666504C8.96536 0.666504 9.99984 1.70098 9.99984 2.97706V5.33317H12.3353C13.9696 5.33317 15.2195 6.78997 14.9709 8.40532L14.253 13.072C14.0529 14.3729 12.9335 15.3332 11.6173 15.3332H2.6665C1.56193 15.3332 0.666504 14.4377 0.666504 13.3332V8.6665C0.666504 7.56193 1.56193 6.6665 2.6665 6.6665H4.23325L6.57933 1.38783ZM5.33317 13.9998H11.6173C12.2754 13.9998 12.8351 13.5197 12.9352 12.8692L13.6531 8.20258C13.7774 7.3949 13.1525 6.6665 12.3353 6.6665H9.99984C9.26346 6.6665 8.6665 6.06955 8.6665 5.33317V2.97706C8.6665 2.46288 8.26939 2.04145 7.76513 2.00274L5.45167 7.20802C5.4183 7.28309 5.37853 7.354 5.33317 7.42023V13.9998ZM3.99984 7.99984V13.9998H2.6665C2.29831 13.9998 1.99984 13.7014 1.99984 13.3332V8.6665C1.99984 8.29831 2.29831 7.99984 2.6665 7.99984H3.99984Z"
        fill="currentColor"
      />
    </svg>
  )
}

IconLike.propTypes = {
  size: PropTypes.number,
}

export default IconLike
